import { useWipRepairOrders } from "@/hooks/RepairOrders";
import { WorkInProgress } from "@/services/api";
import { CheckmarkRegular } from "@fluentui/react-icons";
import { RepairOrdersTable } from "../RepairOrdersTable/RepairOrdersTable";
import * as React from "react";
import styles from "./ViewRepairOrdersButton.module.scss";
import {
	Button,
	Dialog,
	DialogActions,
	DialogBody,
	DialogContent,
	DialogSurface,
	DialogTitle,
	DialogTrigger,
	Label,
	Spinner,
	Tooltip,
} from "@fluentui/react-components";

export interface IViewRepairOrdersButtonProps {
	wip: WorkInProgress;
}

export function ViewRepairOrdersButton(props: IViewRepairOrdersButtonProps) {
	const [isOpen, setIsOpen] = React.useState(false);
	const {
		data: ros,
		isLoading,
		hasRequests,
		hasRos,
		requests: req,
		loadingRequests,
		validatingRequests,
		mutate,
	} = useWipRepairOrders(props.wip.roId!);
	React.useEffect(() => {
		if (isOpen) {
			console.log("mutateRequests", isOpen, hasRequests);
			if (isOpen && hasRequests && !validatingRequests && !loadingRequests) {
				mutate();
			}
		}
	}, [validatingRequests, loadingRequests, isOpen, hasRequests]);
	const loading = isLoading && !hasRos && !hasRequests;
	return (
		<div>
			<Dialog
				onOpenChange={(ev, data) => {
					setIsOpen(data.open);
				}}>
				<DialogTrigger disableButtonEnhancement>
					<div className={styles.roButton}>
						{hasRequests || hasRos ? (
							<div>
								<Tooltip relationship="label" content={"View Service Requests"}>
									<Button icon={<CheckmarkRegular />}>View</Button>
								</Tooltip>
							</div>
						) : (
							<div></div>
						)}
						{loading && <Spinner></Spinner>}
					</div>
				</DialogTrigger>
				<DialogSurface className={styles.dialog}>
					<DialogBody>
						<DialogTitle>Repair Orders for WIP: {props.wip.roNumber}</DialogTitle>
						<DialogContent>
							<div className={styles.vehicleInfo}>
								<div>
									<Label size="large">Vehicle</Label>
									<div>{props.wip.vehicle}</div>
								</div>
								<div>
									<Label size="large">VIN</Label>
									<div>{props.wip.vin}</div>
								</div>
							</div>
							<RepairOrdersTable
								compact
								enableShimmer={hasRequests || loadingRequests || isLoading}
								shimmerRows={req.data?.length || 1}
								repairOrders={ros || []}></RepairOrdersTable>
						</DialogContent>
						<DialogActions>
							<DialogTrigger disableButtonEnhancement>
								<Button appearance="secondary">Close</Button>
							</DialogTrigger>
						</DialogActions>
					</DialogBody>
				</DialogSurface>
			</Dialog>
		</div>
	);
}
